import { render, staticRenderFns } from "./aiCard.vue?vue&type=template&id=4105a9c3&scoped=true&"
import script from "./aiCard.vue?vue&type=script&lang=js&"
export * from "./aiCard.vue?vue&type=script&lang=js&"
import style0 from "./aiCard.vue?vue&type=style&index=0&id=4105a9c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4105a9c3",
  null
  
)

export default component.exports